import React from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { SRLWrapper } from 'simple-react-lightbox';
import { conf } from '../../../confg';
import DeleteButton from './DeleteButton';
import TeammateCalculations from './TeammateCalculations';
import useTeammateRow from '../hooks/useTeammateRow';

const TeammateProductRow = ({ product, index, translate, onDelete, deleteThisProductId }) => {
  const { lightboxOptions, productUrl } = useTeammateRow({ product });
  const isDeleting = deleteThisProductId === product['customers_basket_id'];

  return (
    <div className='teammate-product-row'>
      <div className='teammate-product-content'>
        {/* شماره ردیف */}
        <div className='teammate-row-number'>{index + 1}</div>

        {/* دکمه حذف */}
        <div className='teammate-action-cell'>
          <DeleteButton productId={product['customers_basket_id']} onDelete={onDelete} isDeleting={isDeleting} variant='text' translate={translate} />
        </div>

        {/* تصویر و نام محصول */}
        <div className='teammate-product-info'>
          <SRLWrapper options={lightboxOptions}>
            <LazyLoadImage
              alt={product['products']['accounting_name_model']}
              width={64}
              height={81}
              src={conf.image_url + product['pictures'][0]['url']}
              className='teammate-product-image'
            />
          </SRLWrapper>
          <div className='teammate-product-details'>
            <Link target='_blank' to={productUrl} className='teammate-product-link'>
              <h5 className='teammate-product-title'>{product['products']['accounting_name_product']}</h5>
            </Link>
          </div>
        </div>

        {/* محاسبات */}
        <TeammateCalculations product={product} translate={translate} />
      </div>
    </div>
  );
};

export default TeammateProductRow;
